export * from "./slider.component";
